import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ErrorMessage, Form, Formik } from "formik";
import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getCreditCards, profilePostAction } from "../../actions/profileAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import TextError from "../../components/WraapperComponent/TextError";
import { states } from "../../constants/states";
import { getUserDetail } from "../../utils/helper";
import {
  acumaticaGetCustomerPaymentMethods,
  acumaticaPostAction,
} from "../../actions/acumaticaAction";

const PaymentMethod = ({ closePopup, cardInfo, setListChanged }) => {
  const dispatch = useDispatch();
  const appLoading = useSelector((state) => state.alert.appLoading);
  const initialValues = {
    nameOncard: cardInfo && cardInfo.AccountHolderName,
    cardNumber: cardInfo && cardInfo.CardNumber,
    expirationMonth: cardInfo && cardInfo.CardExpiration.split("/")[0],
    expirationYear:
      cardInfo && cardInfo.CardExpiration.split("/")[1].toString(),
    creditCardNickname: cardInfo && cardInfo.MethodName,
    street: cardInfo && cardInfo.AvsStreet,
    zip: cardInfo && cardInfo.AvsZip,
  };

  const validationSchema = Yup.object({
    nameOncard: Yup.string().nullable().required("This field is required"),
    cardNumber: cardInfo?.CardNumber
      ? Yup.string().nullable().required("This field is required")
      : Yup.string()
          .nullable()
          .min(12, "Credit card number be between 12 and 19 digits long")
          .max(19, "Credit card number be between 12 and 19 digits long")
          .matches(/^[0-9]*$/, "Credit card number is invalid")
          .required("This field is required"),
    expirationMonth: Yup.string()
      .nullable()
      .max(2, "Expiration month be 2 digits long")
      .matches(/^([1-9]|[0][1-9]|[1][0-2])$/, "Expiration month is invalid")
      .required("This field is required"),
    expirationYear: Yup.string()
      .nullable()
      .min(2, "Expiration year be 2 digits long")
      .max(2, "Expiration year be 2 digits long")
      .matches(/^[0-9]*$/, "Expiration year is invalid")
      .required("This field is required"),
    creditCardNickname: Yup.string().nullable(),

    street: Yup.string().nullable().required("This field is required"),

    zip: Yup.string()
      .nullable()
      .max(5)
      .min(5)
      .matches(/^\d{5}$/, "Zip code is not valid")
      .required("This field is required"),
  });

  const onSubmit = (values) => {
    const data = {
      ccName: values.nameOncard,
      ccNumber: cardInfo?.CardNumber ? cardInfo?.CardNumber : values.cardNumber,
      ccExpMonth: values.expirationMonth,
      ccExpYear: values.expirationYear,
      nickname: values.creditCardNickname,
      expiration: values.expirationMonth + values.expirationYear,
      methodId: cardInfo && cardInfo.MethodID,
      street: values.street,
      zip: values.zip,
      customerId: getUserDetail()?.customerId,
    };
    var actionName =
      cardInfo != null
        ? "updateEbizchargeCustomerPaymentMethod"
        : "AddEbizchargeCustomerPaymentMethod";
    var params = {
      params: {
        action: actionName,
        data: data,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      acumaticaPostAction(params, () => {
        dispatch(
          acumaticaGetCustomerPaymentMethods(
            getUserDetail()?.customerId,
            () => {
              setListChanged(true);
            }
          )
        );
        closePopup();
      })
    );
  };
  return (
    <Modal size="lg" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Payment Method</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              errors,
              touched,
              handleChange,
              handleBlur,
              setFieldValue,
              values,
            }) => {
              return (
                <Form>
                  <div className="row">
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Name on card"
                        name="nameOncard"
                        handleBlur={handleBlur}
                        hasError={errors.nameOncard && touched.nameOncard}
                      />
                    </div>

                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Credit card number"
                        name="cardNumber"
                        maxLength={19}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          if (e.target.value.length < 20) {
                            setFieldValue("cardNumber", e.target.value);
                          }
                        }}
                        handleBlur={handleBlur}
                        disabled={cardInfo?.ccNumber}
                        hasError={errors.cardNumber && touched.cardNumber}
                      />
                    </div>
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="number"
                        label="* Expiration Month"
                        name="expirationMonth"
                        maxLength={2}
                        onChange={(e) => {
                          if (e.target.value.length < 3) {
                            setFieldValue("expirationMonth", e.target.value);
                          }
                        }}
                        handleBlur={handleBlur}
                        hasError={
                          errors.expirationMonth && touched.expirationMonth
                        }
                      />
                    </div>

                    <div className="col-sm-6">
                      <div
                        className={
                          errors.expirationYear && touched.expirationYear
                            ? "form-group star has-error"
                            : "star form-group"
                        }
                      >
                        <span className="input-focus"></span>
                        <label htmlFor="expirationYear">
                          * expiration Year
                        </label>
                        <div className="input year-field">
                          <label className="year-text">20-</label>
                          <input
                            type="number"
                            value={values.expirationYear}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              if (e.target.value.length < 3) {
                                setFieldValue("expirationYear", e.target.value);
                              }
                            }}
                            maxLength={2}
                            className="form-control"
                            name="expirationYear"
                          />
                        </div>
                      </div>
                      <ErrorMessage
                        component={TextError}
                        name="expirationYear"
                      />
                    </div>

                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Street"
                        handleBlur={handleBlur}
                        name="street"
                        hasError={errors.street && touched.street}
                      />
                    </div>

                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        handleBlur={handleBlur}
                        label="* Zip code"
                        name="zip"
                        maxLength={5}
                        hasError={errors.zip && touched.zip}
                      />
                    </div>
                    {/* <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        handleBlur={handleBlur}
                        label="Method Name"
                        name="creditCardNickname"
                        hasError={
                          errors.creditCardNickname &&
                          touched.creditCardNickname
                        }
                      />
                    </div> */}
                  </div>
                  <div className="submit-section mt-2">
                    <button
                      className="btn-orange"
                      type="submit"
                      disabled={appLoading}
                    >
                      Save
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default PaymentMethod;
